<template>
  <div>
    <marks v-if="!markProblem" @WebMarkSwitch="WebMarkSwitch"></marks>
    <markProblem v-else  @WebMarkSwitch="WebMarkSwitch"></markProblem>
  </div>
</template>
<script>
import marks from './marks.vue';
import markProblem from './markProblem.vue';
export default {
  name: 'WebMark',
  components: {
    marks,
    markProblem
  },
  data() {
    return {
      markProblem: false
    };
  },
  watch: { },
  methods: {
    WebMarkSwitch(val) {
      this.$emit('WebMarkSwitch', false);
    },
  },
  created: function() {
    this.markProblem = window.location.search.indexOf('from=mbp') !== -1;
  },
  computed: {},
  beforeMount: function() { },
  mounted: function() {
  },
  beforeDestroy: function() { },
  destroyed: function() { },
  directives: {}
};
</script>



// WEBPACK FOOTER //
// src/components/WebMark/index.vue